import FaqIndex from "../pages/landing/faq/FaqIndex";
import AddFAQ from "../pages/landing/faq/FaqAdd";
import EditFAQ from "../pages/landing/faq/FaqEdit";
import FaqBlogList from "../pages/faq/blog faq/FaqBlogIndex";
import AddFaqBlog from "../pages/faq/blog faq/AddFaqBlog";
import EditFaqBlog from "../pages/faq/blog faq/EditFaqBlog";
import FaqCreate from "../pages/faq/plan faq/AddFaqPlan";
import FaqEdit from "../pages/faq/plan faq/EditFaqPlan";

const faqRoutes = [
  {
    path: "faq/plan",
    element: <FaqIndex />,
  },
  {
    path: "faq/plan/add",
    element: <FaqCreate />,
  },
  {
    path: "faq/plan/edit/:id",
    element: <FaqEdit />,
  },
  {
    path: "faq/blog",
    element: <FaqBlogList />,
  },
  {
    path: "faq/blog/add",
    element: <AddFaqBlog />,
  },
  {
    path: "faq/blog/edit/:id",
    element: <EditFaqBlog />,
  },
];

export default faqRoutes;